<template>
    <div class="sui-popup">
        <transition name="sui-animation--slide">
            <ul v-if="show"
                :style="{ 'background': mColor(7) }">
                <li class="sui--title"
                    :style="{ 'color': mColor(1), 'background': `linear-gradient(transparent, transparent 50%, ${ mColor(8.1) } 50%) repeat-x bottom / 1px 1px` }">
                    <div>{{ title }}</div>
                    <sui-icon class="sui--icon" name="close"
                        :style="{ 'fill': mColor(3) }"
                        @click.native="cancel"></sui-icon>
                </li>
                <li class="sui--body">
                    <div class="sui-style--ellipsis-2"
                        :style="{ 'color': mColor(2) }">{{ content }}</div>
                    <div class="sui--options">
                        <div class="sui--option"
                            v-for="(item, i) in options"
                            :key="item"
                            :style="{ 'color': index == i ? mColor(4) : mColor(2.1), 'background': mColor(10) }"
                            @touchstart="index = i">{{ item }}</div>
                    </div>
                </li>
                <li class="sui--confirm"
                    :style="{ 'color': index >= 0 ? mColor(4) : mColor(3), 'border-top-color': mColor(6) }"
                    @click="confirm">{{ button }}</li>
            </ul>
        </transition>
        <transition name="sui-animation--fade-fast">
            <div class="sui--mask"
                v-if="show"
                @click="cancel"></div>
        </transition>
    </div>
</template>

<script>
import Mixin from '../../scripts/mixin'
import SuiIcon from '../icon/icon'

export default {
    name: 'sui-popup',

    mixins: [Mixin],

    components: {
        SuiIcon
    },

    data() {
        return {
            show: false,
            title: '',
            content: '',
            options: [],
            button: '',
            colors: {},
            resolve: {},
            reject: {},

            index: -1
        }
    },

    watch: {
        'show': function (nv) {
            if (!nv) {
                this.index = -1
            }
        }
    },

    methods: {
        confirm() {
            if (this.index < 0) {
                return
            }
            this.show = false
            this.resolve({
                option: this.options[this.index],
                index: this.index,
            })
        },

        cancel() {
            this.show = false
            this.reject()
        },

        /**
         * 返回带透明度的颜色值
         * @param {Number} index - 配色规范色号
         */
        rgba(index) {
            index = index.toString()
            let opacity = 1
            switch (index) {
                case '2.1':
                    opacity = 0.65
                    break
                case '3.1':
                    opacity = 0.5
                    break
                case '8.1':
                    opacity = 0.6
                    break
                case '8.2':
                    opacity = 0.3
                    break
                case '15.1':
                    opacity = 0.8
                    break
            }
            let str = this.colors[index.split('.')[0]]
            return str.includes('#') ? `rgba(${ Number.parseInt(str.substr(1, 2), 16) }, ${ Number.parseInt(str.substr(3, 2), 16) }, ${ Number.parseInt(str.substr(5, 2), 16) }, ${ opacity })` : str.replace('1)', opacity + ')')
        },
    }
}
</script>

<style lang="postcss">
.sui-popup {
    > ul {
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 110;
        width: 100%;
        margin: 0;
        padding: 0;
        font-size: 17px;
        li {
            margin: 0;
            padding: 0;
        }
        .sui--title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 45px;
            padding: 0 15px;
            font-size: 16px;
            .sui--icon {
                width: 20px;
            }
        }
        .sui--title::before {
            content: "";
            width: 18px;
        }
        .sui--body {
            font-size: 12px;
            @media (orientation: portrait) {
                padding: 15px 30px;
            }
            @media (orientation: landscape) {
                padding: 15px 86px;
            }
            .sui--options {
                display: flex;
                flex-wrap: wrap;
                .sui--option {
                    flex: none;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 36px;
                    margin: 15px 15px 0 0;
                    border-radius: 4px;
                    @media (orientation: portrait) {
                        width: calc((100% - 15px) / 2);
                    }
                    @media (orientation: landscape) {
                        width: calc((100% - 45px) / 4);
                    }
                }
                .sui--option:nth-child(even) {
                    @media (orientation: portrait) {
                        margin-right: 0;
                    }
                }
                .sui--option:nth-child(4n) {
                    @media (orientation: landscape) {
                        margin-right: 0;
                    }
                }
            }
        }
        .sui--confirm {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50px;
            border-top: 10px solid;
            font-weight: 500;
            @media (max-aspect-ratio: 1/2) {
                padding-bottom: var(--safe-area-inset-bottom);
            }
            @media (min-aspect-ratio: 2/1) {
                padding-bottom: var(--safe-area-inset-bottom);
            }
        }
    }
    > .sui--mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
    }
}
</style>